import React, { useEffect } from 'react';
import styled, { createGlobalStyle } from 'styled-components';

// Global style to prevent scrolling on both html and body
const NoScrollStyle = createGlobalStyle`
  html, body {
    overflow: hidden !important;
    height: 100% !important;
    width: 100% !important;
    position: fixed !important;
    margin: 0 !important;
    padding: 0 !important;
  }
`;

// Component that applies the style when mounted
const ScrollLock = () => {
  useEffect(() => {
    // Optional: Save previous overflow styles to restore them on unmount
    const htmlOverflow = document.documentElement.style.overflow;
    const bodyOverflow = document.body.style.overflow;
    
    // Clean up function to restore styles when unmounted
    return () => {
      document.documentElement.style.overflow = htmlOverflow;
      document.body.style.overflow = bodyOverflow;
    };
  }, []);
  
  return <NoScrollStyle />;
};

export default ScrollLock; 